export default "__VITE_PUBLIC_ASSET__912e5d6a__"